module.exports = __webpack_public_path__ + "static/media/02-floracaroli-hover.9a0324f8.jpg";